import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';

import Log from './Log';
import Toplist from './Toplist';
import Insights from './Insights';
import Events from './Events';

const tabs = [Log, Toplist, Insights, Events];

const deps = {
  currentTab: state.challenge.currentTab,
};

export function Tabs({
  currentTab,
}: typeof deps & ConnectedProps): React.ReactElement {
  const Tab = tabs[currentTab];

  if (Tab) {
    return <Tab />;
  }

  return null;
}

export default connect(deps, Tabs);
